import { render, staticRenderFns } from "./RegisterForAssessment.vue?vue&type=template&id=5634c304&scoped=true&"
import script from "./RegisterForAssessment.vue?vue&type=script&lang=ts&"
export * from "./RegisterForAssessment.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterForAssessment.vue?vue&type=style&index=0&id=5634c304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634c304",
  null
  
)

export default component.exports